import { render, staticRenderFns } from "./KnowledgeCheckFeedback.vue?vue&type=template&id=685d5306&scoped=true&lang=pug"
import script from "./KnowledgeCheckFeedback.vue?vue&type=script&lang=ts"
export * from "./KnowledgeCheckFeedback.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeCheckFeedback.vue?vue&type=style&index=0&id=685d5306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d5306",
  null
  
)

export default component.exports